import gql from 'graphql-tag'

export const GET_ORGANIZATION_MESSAGES = gql`
  query GetOrganizationMessages($organizationSlug: String!) {
    getOrganizationMessages(organizationSlug: $organizationSlug) {
      id
      title
      message
      sent
    }
  }
`

export const GET_ORGANIZATION_MESSAGE = gql`
  query GetOrganizationMessage($organizationSlug: String!, $organizationMessageId: Int!) {
    getOrganizationMessages(
      organizationSlug: $organizationSlug
      organizationMessageId: $organizationMessageId
    ) {
      id
      title
      message
      sent
    }
  }
`

export const CREATE_ORGANIZATION_MESSAGE = gql`
  mutation CreateOrganizationMessage(
    $organizationSlug: String!
    $data: OrganizationMessageCreateInput!
  ) {
    createOrganizationMessage(organizationSlug: $organizationSlug, data: $data)
  }
`

export const UPDATE_ORGANIZATION_MESSAGE = gql`
  mutation UpdateOrganizationMessage(
    $organizationSlug: String!
    $data: OrganizationMessageUpdateInput!
  ) {
    updateOrganizationMessage(organizationSlug: $organizationSlug, data: $data)
  }
`

export const DELETE_ORGANIZATION_MESSAGE = gql`
  mutation DeleteOrganizationMessage($organizationSlug: String!, $organizationMessageId: Int!) {
    deleteOrganizationMessage(
      organizationSlug: $organizationSlug
      organizationMessageId: $organizationMessageId
    )
  }
`

export const SEND_ORGANIZATION_MESSAGE = gql`
  mutation SendOrganizationMessage($organizationSlug: String!, $organizationMessageId: Int!) {
    sendOrganizationMessage(
      organizationSlug: $organizationSlug
      organizationMessageId: $organizationMessageId
    )
  }
`
